module.exports = function() {
  return new Worker(__webpack_public_path__ + "5de20e444341e347f5fd.worker.js");
};